module.exports = __webpack_public_path__ + "static/media/3.ad4e1137.jpg";